const store = {
    isSignedIn :false
}

store.install = function (Vue) {
    Vue.observable(store);
    Vue.prototype.$store = store;
}

export default store;